<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">

  <!-- Main Title Section -->
  <div class="page-title-section">
    <h2>Assurance Mutuelle Santé Individuelle</h2>
  </div>

  <!-- Intro Text -->
  <div class="intro-text">
    <p>
      Le contrat d'assurance Mutuelle Santé Individuelle a pour objet de garantir le remboursement des dépenses de santé 
      de tout ou partie des frais médicaux, chirurgicaux et/ou d'hospitalisation occasionnées par une maladie, un accident 
      ou une maternité survenus pendant la période d'adhésion, ainsi que les frais de santé non pris en charge par votre 
      Régime Obligatoire de Sécurité Sociale (SS), au profit des personnes assurées définies sur votre contrat, dans les 
      conditions et limites des niveaux de garanties souscrites précisées au contrat, ainsi que dans la limite des frais 
      réels et de la base de remboursement de la SS.
    </p>
  </div>

  <!-- Courtier Section -->
  <div class="courtier-section">
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : 
      <strong class="highlight-purple">GENERALI, MATMUT, APRIL, AXA SPVIE, SWISSLIFE, MALAKOFF HUMANIS, ALPTIS, 
      ASAF &amp; AFPS, HENNER, APIVIA MACIF, AVENIR MUTUELLE, IDENTITE MUTUELLE, UCR, PRAECONIS…MATMUT</strong>
    </p>
  </div>

  <!-- Devis Button -->
  <div class="devis-button-section">
    <button class="btn-devis-large" (click)="navigateToDevis()">
      Devis en ligne
    </button>
  </div>

  <!-- Main Content Section -->

  <div class="content-section">
    <h3>Une protection indispensable pour protéger votre santé</h3>
    <p>Votre contrat assurance santé vous garantit donc pour :</p>
    <ul>
      <li>les consultations et soins de médecins généralistes ou spécialistes,</li>
      <li>les frais de radiologie, d'échographie,</li>
      <li>les frais d'analyses médicales et d'auxiliaires médicaux,</li>
      <li>la pharmacie (médicaments remboursés par la Sécurité sociale),</li>
      <li>les prothèses dentaires</li>
      <li>les prothèses non dentaires</li>
      <li>les médecines douces</li>
      <li>le bien-être : Cure thermale…</li>
      <li>l'appareillage : appareil auditif, orthèse (semelle orthopédique, ….)</li>
    </ul>
  </div>

  <div class="content-section">
    <h3>Le saviez-vous ?</h3>
    <p>
      Face au désengagement progressif de la Sécurité sociale en matière de frais de santé, le reste à charge (ce qui 
      reste à payer de votre poche) pour les patients ne cesse de s'alourdir. D'autant que la consommation de soins et 
      de biens médicaux tend à croître à mesure que l'on avance en âge… En effet, pour les seniors par exemple, des études 
      indiques que les dépenses de santé sont multipliés par 3,5 entre 55 ans et 80 ans, le poste hospitalisation prend 
      une place de plus en plus importante dans les soins. Pourquoi ? Le coût d'une hospitalisation peut varier entre 
      66€ et 446€/j. Il ne faut donc pas se tromper de formules.
    </p>
    <p>
      Dans ce contexte, disposer d'une couverture santé adaptée répondant à ses attentes et à son budget tout en bénéficiant 
      de bons niveaux de remboursement est indispensable.
    </p>
    <p>
      Avec l'âge, lorsque l'état de santé se détériore, certains besoins de remboursement deviennent coûteux et répétitifs 
      pour l'assuré surtout si il n'est pas assurée en complémentaire santé puisque que ticket modérateur et dépassement 
      d'honoraire (partie des honoraires dépassant le tarif de convention de la sécurité sociale, ex: 23€ pour un 
      généraliste) resteront à charge, en voici une liste non-exhaustive :
    </p>
  </div>

  <div class="content-section highlight-section">
    <h3>Hospitalisation :</h3>
    <p>
      Les frais liés à une hospitalisation : Une hospitalisation peut arriver soudainement et rapidement devenir coûteuse 
      et inquiétante pour votre entourage. Si vous avez une couverture de base à la sécurité sociale, vous devrez régler 
      le « ticket modérateur », soit 20 % du prix de journée (hébergement, médicaments, examens de laboratoire, soins, 
      interventions chirurgicales, frais de salle d'opération, produits sanguins, actes de radiologie, prothèses). Des 
      dépassements d'honoraires peuvent également être pratiqués par des médecins hospitaliers exerçant en profession 
      libérale. Le tarif des prestations hospitalières correspond aux coûts des frais de santé et dépend donc du problème 
      des santé donnant lieu à l'hospitalisation. Il est défini sous la forme d'un montant par jour d'hospitalisation:
    </p>
    <ul>
      <li>Pour les hôpitaux publics et privés sans but lucratif, ce montant est défini par chaque directeur d'établissement 
      et donc variable d'un hôpital à l'autre,</li>
      <li>Pour les cliniques /hôpitaux privés, ce montant est défini nationalement et donc le même dans chaque établissement.</li>
    </ul>
    <p>
      Une attention particulière à porter aux attentes des assurés, est le remboursement de la chambre particulière et des 
      actes de spécialité en secteur conventionné (cardiologie, rhumatologie…):
    </p>
    <ul>
      <li>Hospitalisation : Généralement, les frais de séjour et Chirurgie sont pris en charge sur la base des frais réels 
      par les formules intermédiaires des complémentaires santé,</li>
      <li>Après une hospitalisation, des mutuelles financent à hauteur de 30/60j les maisons de repos,</li>
      <li>Les chambres particulières ainsi que les extras sont également pris en charge sur une bonne base par les formules 
      intermédiaires des complémentaires santé (80€/j).</li>
    </ul>
  </div>

  <div class="content-section">
    <h3>Optiques :</h3>
    <p>
      Avec le temps le vue baisse, l'achat de lunettes de qualités est très importantes. Les lunettes avec correction simple 
      sont généralement remboursées à hauteur de 5 euro, pour les verres complexes et très complexes en optique, le 
      remboursement restent très en dessous des frais réels. Bien que la réforme 100% santé soit passée, il se peut que par 
      coquetterie vous vouliez avoir une monture de marque. Certaines mutuelles peuvent prendre tout ou partie du prix des 
      montures.
    </p>
  </div>

  <div class="content-section">
    <h3>Dentaires non remboursés :</h3>
    <p>
      Que vous soyez une personne agée, ou non, et vous avez un besoin très particulier en dentaire, notamment sur les postes 
      de Prothèses, d'implants, et de parodontologie une bonne assurance santé est nécessaire. Quand on sait qu'un prothèse 
      compléte peut couter jusqu'à 1000 €, et que la sécu en rembourse que 90€, le besoin de couverture s'en fait sentir.
    </p>
  </div>

  <div class="content-section">
    <h3>Médecines douces/naturelles et préventions :</h3>
    <p>
      Les médecines non-traditionnelles ont le vent en poupe. Toutes les mutuelles ne les prennent pas en charge. Par ailleurs, 
      deux types de besoins peuvent répondre aux personnes voulant réduire leur rapport à médecine conventionnelle:
    </p>
    <p>
      La cure thermale (Attention : ne confondez pas thermalisme et thalassothérapie. La thalassothérapie propose des 
      prestations exclusivement préventives et de bien-être qui ne sont pas prises en charge par l'Assurance Maladie, alors 
      que le thermalisme délivre des soins contre des maladies chroniques. Ces soins peuvent être remboursés par l'Assurance 
      Maladie.) ainsi que des besoins en Pédicure, podologue, ostéopathie, kinésithérapie, etc etc … .
    </p>
  </div>

  <div class="content-section">
    <h3>Audition :</h3>
    <p>
      Différentes causes peuvent expliquer la survenue de la déficience auditive mais pour la majorité des individus, la 
      raison principale en est l'usure des cellules sensorielles avec l'âge. Celle-ci commence de plus en plus tôt et est 
      apparente vers 55 ans. Or, en France, l'âge moyen du premier équipement est de 70 ans. Le besoin des seniors est donc 
      dans l'équipement en petit appareillage auditif, dont le prix est de l'ordre de 1500 euros/ oreille.
    </p>
  </div>

  <div class="content-section">
    <h3>Frais accessoires :</h3>
    <ul>
      <li>ostéodensiométrie, diagnostic prostate, Petit appareillage non remboursé (bas de contention) : pouvant aller jusqu'à 
      100 € chez certains assureurs.</li>
      <li>Traitement ménopause / andropause (traitements érectiles) / insuffisance veineuse (traitements veinotiques): pouvant 
      aller jusqu'à 100 € chez chez certains assureurs.</li>
      <li>Forfait sexualité et vie de couple : consultation d'un sexologue, médicaments des troubles erectiles comme le viagra 
      et lubrifiants.</li>
    </ul>
  </div>

  <div class="content-section">
    <h3>Pharmacie :</h3>
    <p>
      Si la pharmacie reste bien remboursée, un certain nombre de produits ne le sont pas. Certaines mutuelles proposent un 
      budget annuel dédié au remboursement des médicaments non remboursés par l'assurance maladie.
    </p>
  </div>

  <div class="content-section">
    <h3>L'absence d'avance de frais :</h3>
    <p>
      Sur simple présentation de votre carte de Tiers Payant Étendu, vous êtes dispensé d'avance de frais (dans la limite des 
      garanties de votre contrat) chez près de 160 000 professionnels de la santé dont plus de 10 000 opticiens indépendants 
      ou franchisés, des différents réseaux de soins (Réseau Carte Blanche etc ).
    </p>
  </div>

  <div class="content-section">
    <p>
      Bien évidement les possibilités en termes de couvertures sont énormes. Il existe des milliers de combinaisons possibles. 
      Néanmoins, d'un assureur à un autre, les services (la qualité de gestion) ne sont pas les mêmes.
    </p>
    <p>
      Dans le cas d'une couverture en assurance santé en déplacement ou pour un voyage de plus de 3 mois à l'étranger, il vous 
      sera nécessaire de souscrire à une <strong class="highlight-purple">Assurance Mutuelle Santé Internationale</strong> que vous 
      retrouverez ici.
    </p>
    <p>
      Si vous êtes autoentrepreneur ou un professionnel en entreprise individuelle, il vous faudra plutôt souscrire une 
      assurance <strong class="highlight-purple">Assurance Mutuelle Santé Professionnelle</strong> que vous trouverez en 
      cliquant ici.
    </p>
  </div>

  <!-- Bottom Devis Button -->
  <div class="devis-button-section">
    <button class="btn-devis-large" (click)="navigateToDevis()">
      Devis en ligne
    </button>
  </div>

</app-page-layout>
